import { useState } from "react"
import PropTypes from "prop-types"
import { Checkbox } from "components/ui"
import RegistrationContact from "components/admin/registration_contact"
import AddAttendees from "components/admin/LegacyRegistration/AddAttendees"
import { api } from "utils/api"

const RegistrationsNew = ({ attendeeTypes, paths }) => {
  const [isValid, setIsValid] = useState(false)
  const [error, setError] = useState(null)
  const [attendeesToUpdate, setAttendeesToUpdate] = useState([])
  const [sendConfirmation, setSendConfirmation] = useState(false)
  const [registrationContact, setRegistrationContact] = useState(null)

  const handleAttendeesChange = (newAttendees, attrs) => {
    setAttendeesToUpdate(newAttendees)
    if (!registrationContact && newAttendees[0].personId) {
      setRegistrationContact(newAttendees[0])
    }
    setIsValid(attrs.isValid)
  }

  const handleSaveClick = () => {
    setIsValid(false)

    const peopleAttrs = attendeesToUpdate.map(a => {
      return {
        person_id: a.personId,
        attendee_type_id: a.attendeeTypeId,
        ...(registrationContact && {
          responsible_person_id: registrationContact.id
        })
      }
    })

    const data = {
      attendees_attributes: peopleAttrs,
      ...(sendConfirmation && { send_confirmation: 1 }),
      ...(registrationContact && {
        responsible_person_id: registrationContact.id
      })
    }

    return api
      .post(paths.registrationCreate, {
        registration: data
      })
      .then(_res => Turbolinks.visit(paths.eventShow))
      .catch(res => setError(res.errors))
  }

  const handleCancelClick = () => {
    Turbolinks.visit(paths.eventShow)
  }

  const handleRegistrationContactSelect = async accountCenterPerson => {
    let person = accountCenterPerson
    if (accountCenterPerson.account_center_id) {
      const data = await api.post(`${paths.accountsPeople}`, {
        person: { account_center_id: accountCenterPerson.account_center_id }
      })
      person = data.person
    }
    setRegistrationContact(person)
  }

  const handleConfirmationSelect = () => {
    setSendConfirmation(!sendConfirmation)
  }

  return (
    <>
      <section className="pane pb-1 mb-1 print-box mb-2@print">
        <div className="p-r p-2 print-box mb-2@print" style={{ zIndex: 2 }}>
          <h1 className="h4 fw-600 mb-1">Attendees</h1>

          <AddAttendees
            accountsPeoplePath={paths.accountsPeople}
            attendeeTypes={attendeeTypes}
            onAttendeesChange={handleAttendeesChange}
          />
        </div>

        <div className="line p-r p-2" style={{ zIndex: 1 }}>
          <h1 className="h4 fw-600 mb-2">Registration contact</h1>
          <RegistrationContact
            onSelect={handleRegistrationContactSelect}
            helpText="All correspondence for this registration will be sent to this person"
            suggestedPeople={attendeesToUpdate}
            responsiblePerson={registrationContact}
            editMode={true}
          />
        </div>

        <div className="line p-2 print-box mb-2@print">
          <div css={{ display: "inline-block" }}>
            <Checkbox
              name="send_confirmation"
              htmlFor="send_confirmation"
              text="Send confirmation email"
              checked={sendConfirmation}
              onSelect={handleConfirmationSelect}
              wrapperClasses="mb-0"
            />
          </div>
        </div>
      </section>

      {error && <div className="p-2 error-alert">{error}</div>}

      <div className="mt-3 ta-r">
        <button onClick={handleCancelClick} className="btn-ghost mr-1">
          Cancel
        </button>
        <button disabled={!isValid} className="btn-solid interaction" onClick={handleSaveClick}>
          Complete registration
        </button>
      </div>
    </>
  )
}

RegistrationsNew.propTypes = {
  attendeeTypes: PropTypes.array,
  paths: PropTypes.shape({
    eventShow: PropTypes.string,
    registrationCreate: PropTypes.string,
    accountsPeople: PropTypes.string
  })
}

export default RegistrationsNew
